import type { SubscriptionLocations } from './subscription';
import SubscriptionLocationsImpl from './subscriptionImpl';

export type { SubscriptionLocations };
export default SubscriptionLocationsImpl;
